module.exports = __webpack_public_path__ + "static/media/Adviesbox_ADV.b45588ea.png";